import React, { useRef } from 'react';
import EditorJs from 'react-editor-js';
import Header from '@editorjs/header';
import List from '@editorjs/list';
import LinkTool from '@editorjs/link';
import Image from '@editorjs/image';
import Quote from '@editorjs/quote';
import Delimiter from '@editorjs/delimiter';
import Marker from '@editorjs/marker';
import Table from '@editorjs/table';
import Paragraph from '@editorjs/paragraph';
import API from '../../api/api';
import uuid from "uuid";

const garageApi = new API();

const EDITOR_JS_TOOLS = {
  header: {
    class: Header,
    config: {
      levels: [1, 2, 3],
      defaultLevel: 2
    }
  },
  paragraph: {
    class: Paragraph,
    inlineToolbar: true,
  },
  list: {
    class: List,
    inlineToolbar: true,
  },
  quote: {
    class: Quote,
    inlineToolbar: true,
  },
  marker: {
    class: Marker,
  },
  linkTool: {
    class: LinkTool,
  },
  image: {
    class: Image,
    config: {
      uploader: {
        async uploadByFile(file) {
          const formData = new FormData();
          formData.append("image", file);
          formData.append('type', 'default');
          formData.append('name', 'Editor-Image');
          formData.append('unikey', uuid.v4());

          try {
            const response = await garageApi.endpoints.image.create(formData, {
              timeout: 120000,
              maxContentLength: Infinity,
              maxBodyLength: Infinity,
            });
            const img = response.data?.image || {};
            return {
              success: 1,
              file: {
                url: img.large || img.medium || img.original || img.full || img.small,
              },
            };
          } catch (error) {
            console.error('Image upload error:', error);
            return { success: 0, message: error?.response?.data?.message || error.message };
          }
        }
      }
    }
  },
  delimiter: Delimiter,
  table: {
    class: Table,
    inlineToolbar: true,
  },
};

const RichTextEditor = ({ data, onChange, placeholder = "Beginnen Sie mit dem Schreiben..." }) => {
  const editorInstance = useRef(null);

  const handleReady = () => {
    // Editor is ready
  };

  const handleChange = async (api, event) => {
    try {
      const outputData = await api.saver.save();
      if (onChange) {
        onChange(outputData);
      }
    } catch (error) {
      console.error('Error saving editor data:', error);
    }
  };

  return (
    <div style={{ 
      minHeight: '300px',
      border: '1px solid #e0e0e0',
      borderRadius: '4px',
      backgroundColor: 'white',
      padding: '10px'
    }}>
      <EditorJs
        instanceRef={(instance) => (editorInstance.current = instance)}
        tools={EDITOR_JS_TOOLS}
        data={data || { blocks: [] }}
        placeholder={placeholder}
        onReady={handleReady}
        onChange={handleChange}
      />
    </div>
  );
};

export default RichTextEditor;
